// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"00add6b3","439":"c5d2c746"}[chunkId] + ".chunk.js";
};